import { ThemeOptions } from '@mui/material';

import { accordionConfigs } from './accordion';
import { alertConfigs } from './alert';
import { autocompleteConfigs } from './autocomplete';
import { avatarConfigs } from './avatar';
import { buttonConfigs } from './button';
import { buttonBaseConfigs } from './buttonBase';
import { chipConfigs } from './chip';
import { containerConfigs } from './container';
import { cssBaseLineConfigs } from './cssBaseline';
import { dividerConfigs } from './divider';
import { drawerConfigs } from './drawer';
import { formLabelConfigs } from './formLabel';
import { listItemConfigs } from './listItem';
import { menuConfigs } from './menu';
import { modalConfigs } from './modal';
import { selectConfigs } from './select';
import { snackbarConfigs } from './snackbar';
import { stackConfigs } from './stack';
import { tabConfigs } from './tab';
import { tabsConfigs } from './tabs';
import { textFieldConfigs } from './textField';
import { toggleButtonGroupConfigs } from './toggleButtonGroup';
import { tooltipsConfigs } from './tooltip';
import { typographyConfigs } from './typography';

export const componentsConfigs: ThemeOptions['components'] = {
  MuiAccordion: accordionConfigs,
  MuiAlert: alertConfigs,
  MuiAutocomplete: autocompleteConfigs,
  MuiAvatar: avatarConfigs,
  MuiButton: buttonConfigs,
  MuiButtonBase: buttonBaseConfigs,
  MuiChip: chipConfigs,
  MuiContainer: containerConfigs,
  MuiCssBaseline: cssBaseLineConfigs,
  MuiDivider: dividerConfigs,
  MuiDrawer: drawerConfigs,
  MuiFormLabel: formLabelConfigs,
  MuiListItem: listItemConfigs,
  MuiMenu: menuConfigs,
  MuiModal: modalConfigs,
  MuiSelect: selectConfigs,
  MuiSnackbar: snackbarConfigs,
  MuiStack: stackConfigs,
  MuiTab: tabConfigs,
  MuiTabs: tabsConfigs,
  MuiTextField: textFieldConfigs,
  MuiToggleButtonGroup: toggleButtonGroupConfigs,
  MuiTooltip: tooltipsConfigs,
  MuiTypography: typographyConfigs,
};
